AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "ProblemStats");

AoPS.Alcumus.Models.ProblemStats = (function () {
	// Dependencies
	var AlcMBase = AoPS.Alcumus.Models.Base;

	return AlcMBase.BaseModel.extend({
		// first, correct, incorrect, giveup are sent from server. The rest are
		// computed in the updateAux method;
		defaults: {
			first: 0,
			second: 0,
			correct: 0,
			incorrect: 0,
			giveup: 0,
			total: 0,
			percent: 0,
		},

		initialize: function () {
			// correct, first, incorrect, giveup are the basic fields.
			// The rest are 'composite' and computed from them in updateAux.
			this.listenTo(
				this,
				"change:first change:correct change:incorrect change:giveup",
				this.updateAux
			);
			this.updateAux();
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			var set_data = {};

			_.each(
				_.keys(this.defaults),
				function (field) {
					var data_field = "num_" + field;
					if (data[data_field]) {
						set_data[field] = parseInt(data[data_field], 10);
					}
				},
				this
			);
			this.set(set_data);
			this.updateAux();
		},

		updateAux: function () {
			var correct = this.get("correct");
			this.set("second", correct - this.get("first"));
			var total = correct + this.get("incorrect") + this.get("giveup");
			this.set("total", total);
			this.set("percent", this.asPercent(correct, total));
		},

		asPercent: function (num, denom) {
			if (denom === 0) {
				return "N/A";
			} else {
				return Math.round((10000 * num) / denom) / 100;
			}
		},
	});
})();
